var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-sm-and-up bg"},[_c('div',{staticClass:"mobile_callme_wrap"},[_c('p',[_c('span',[_vm._v("利川市靓利建设工程有限公司")]),_c('span',{staticStyle:{"margin-left":"20px"}},[_vm._v("版权公司所有")]),_c('span',{staticStyle:{"margin-left":"20px"}},[_vm._v("公关备案1111111111")])])])])
}]

export { render, staticRenderFns }